import ArticleIcon from "@mui/icons-material/Article";
import MenuIcon from "@mui/icons-material/Menu";
import {
  Box,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import viewpaths from "global/constants/ViewPathConstants";
import { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import adminSideNavLayoutStyles from "./AdminSideNavLayout.styles";

const NAV_ITEMS = [
  {
    path: viewpaths.adminBlogsViewPath,
    label: "Generated Blogs",
    icon: <ArticleIcon fontSize="small" />,
  },
  // {
  //   path: viewpaths.adminAnalyticsViewPath,
  //   label: "Analytics",
  //   icon: <AnalyticsIcon fontSize="small" />,
  // },
  // {
  //   path: viewpaths.adminProfileViewPath,
  //   label: "Profile",
  //   icon: <PersonIcon fontSize="small" />,
  // },
];

interface AdminSideNavLayoutProps {
  children: React.ReactNode;
}

const AdminSideNavLayout = ({ children }: AdminSideNavLayoutProps) => {
  const theme = useTheme();
  const history = useHistory();
  const location = useLocation();
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));
  const [mobileOpen, setMobileOpen] = useState(false);
  const styles = adminSideNavLayoutStyles;

  const handleNav = (path: string) => {
    history.push(path);
    setMobileOpen(false);
  };

  const sidebar = (
    <Box sx={styles.sidebar}>
      <Box sx={styles.sidebarHeader}>
        <Typography sx={styles.logoText}>Panacea Admin</Typography>
      </Box>
      <List sx={styles.navList}>
        {NAV_ITEMS.map((item) => {
          const isSelected = location.pathname === item.path;
          return (
            <ListItem
              key={item.path}
              button
              selected={isSelected}
              onClick={() => handleNav(item.path)}
              sx={styles.navItem}
            >
              <ListItemIcon sx={{ minWidth: 40 }}>{item.icon}</ListItemIcon>
              <ListItemText primary={item.label} />
            </ListItem>
          );
        })}
      </List>
    </Box>
  );

  const sidebarInDrawer = (
    <Box sx={styles.sidebarInDrawer}>
      <Box sx={styles.sidebarHeaderInDrawer}>
        <Typography sx={styles.logoText}>Panacea Admin</Typography>
      </Box>
      <List sx={styles.navListInDrawer}>
        {NAV_ITEMS.map((item) => {
          const isSelected = location.pathname === item.path;
          return (
            <ListItem
              key={item.path}
              button
              selected={isSelected}
              onClick={() => handleNav(item.path)}
              sx={styles.navItemInDrawer}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.label} />
            </ListItem>
          );
        })}
      </List>
    </Box>
  );

  return (
    <Box sx={styles.root}>
      {!isMobile && sidebar}
      {isMobile && (
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={() => setMobileOpen(false)}
          ModalProps={{ keepMounted: true }}
          sx={{
            "& .MuiDrawer-paper": {
              width: 280,
              boxSizing: "border-box",
              top: 120,
              height: "calc(100% - 120px)",
              borderRadius: "0 12px 0 0",
            },
          }}
        >
          {sidebarInDrawer}
        </Drawer>
      )}
      <Box component="main" sx={styles.main}>
        {isMobile && (
          <Box sx={styles.mobileMenuButtonWrapper}>
            <Box
              component="button"
              type="button"
              onClick={() => setMobileOpen(true)}
              sx={styles.mobileMenuButtonPill}
              aria-label="Open admin menu"
            >
              <IconButton size="small" sx={styles.mobileMenuButton} aria-hidden>
                <MenuIcon />
              </IconButton>
            </Box>
          </Box>
        )}
        {children}
      </Box>
    </Box>
  );
};

export default AdminSideNavLayout;
